<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GfeGPy/tc-custom/FC-9781528909150.jpg?1684514747609?1731166562838" alt="This image is the cover for the book Environmental Chemistry and You"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Environmental Chemistry and You
      </h1>
      <p class="bookDescription body article font2">
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin interdum commodo est, porttitor fermentum nibh sagittis et. Mauris rutrum ante quis nisl dignissim convallis. Donec vehicula turpis id lorem tristique interdum. Nulla et tellus massa. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Vestibulum scelerisque turpis ac arcu auctor sodales. Morbi eleifend mauris eleifend ullamcorper dignissim. Quisque nisl nunc, mollis a blandit hendrerit, finibus sed massa. Donec et condimentum lorem. Suspendisse molestie gravida auctor. Maecenas gravida vel justo sit amet condimentum. Duis a nunc eleifend, placerat eros sed, interdum metus. Phasellus ac pulvinar ipsum, vel scelerisque tortor. Nullam in elit eget lorem congue lacinia in elementum metus. Praesent eget finibus mi. Fusce porttitor, ex et consectetur dignissim, enim elit commodo neque, eu bibendum augue sapien eu nisi. Curabitur sed eros rhoncus, pellentesque risus venenatis, tristique nunc. Maecenas sed laoreet enim, eu hendrerit velit. Proin pharetra, ante quis dictum scelerisque, mauris arcu commodo metus, sit amet molestie nibh dui at urna. Donec suscipit imperdiet enim, ac pretium eros euismod sit amet. Duis ut lacinia dolor. Phasellus lobortis sed dolor sit amet blandit. Cras convallis condimentum ex, in accumsan nulla sodales quis. Nunc vitae massa lectus. Duis.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kjell Aas
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?70055e26